import {
  SendOtp,
  SendOtpV2,
  SendUserOtp,
  SendUserOtpV2,
  VerifyOtp,
  VerifyOtpV2,
  VerifyUserOtp,
  VerifyUserOtpV2
} from 'helpers/models';

export const mapSendUserOtp = (result) => {
  return new SendUserOtp(result).mapToStandard();
};

export const mapSendUserOtpv2 = (result) => {
  return new SendUserOtpV2(result).mapToStandard();
};

export const mapSendOtp = (result) => {
  return new SendOtp(result).mapToStandard();
};

export const mapSendOtpv2 = (result) => {
  return new SendOtpV2(result).mapToStandard();
};

export const mapVerifyUserOtp = (result) => {
  return new VerifyUserOtp(result).mapToStandard();
};

export const mapVerifyUserOtpv2 = (result) => {
  return new VerifyUserOtpV2(result).mapToStandard();
};

export const mapVerifyOtp = (result) => {
  return new VerifyOtp(result).mapToStandard();
};

export const mapVerifyOtpv2 = (result) => {
  return new VerifyOtpV2(result).mapToStandard();
};
